import tokens from './tokens'
import { PoolConfig, PoolCategory } from './types'

const pools: PoolConfig[] = [
  {
    sousId: 0,
    stakingToken: tokens.axd,
    earningToken: tokens.axd,
    contractAddress: {
      97: '0x3929b0537fa92a666d574920e2898f55ea72c6fc',
      56: '0x3929b0537fa92a666d574920e2898f55ea72c6fc',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '2',
    sortOrder: 1,
    isFinished: false,
  },
  
  {
    sousId: 1,
    stakingToken: tokens.axt,
    earningToken: tokens.axd,
    contractAddress: {
      97: '',
      56: '0x2401ba4f7ce00d83dae3a6ea774482460b34bc7c',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '0.25',  
    },
	
	{
    sousId: 2,
    stakingToken: tokens.axt,
    earningToken: tokens.axd,
    contractAddress: {
      97: '',
      56: '0xd1c765eedbaf81d3425dbceb9e32a3c0a6e29e5e',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 999,
    tokenPerBlock: '0.10',  
    },
   
]

export default pools
